import React from 'react';
import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import { Button } from '@gn-audio/jss-components';

import { useHearingTestTracking } from '../HearingTestContext';
import { translations } from '../translations/en';
import { ResultTile } from '../types/SitecoreFields';
import { HearingTestEventAction } from '../types/TrackingTypes';

interface RecommendedProductTileProps {
  product: ResultTile;
}

export const RecommendedProductTile: React.FC<RecommendedProductTileProps> = ({ product }) => {
  const { trackHearingTestEvent } = useHearingTestTracking();

  const handleProductClick = () => {
    trackHearingTestEvent(
      HearingTestEventAction.ClickResultLink,
      product.id || product.productName.value
    );
    const href = product.ctaButtonLink.value.href;
    if (href) {
      window.location.href = href;
    }
  };
  return (
    <div className="flex flex-col gap-8 overflow-hidden rounded-lg border p-6 shadow-lg md:flex-row">
      {product.productImage?.value?.src && (
        <div className="flex-shrink-0 md:w-64">
          <Image field={product.productImage} className="h-64 w-full object-cover md:h-full" />
        </div>
      )}
      <div className="flex flex-1 flex-col">
        <p className="mb-4 text-xl font-bold text-gray-900">{product.productName.value}</p>
        {product.productDescription?.value && (
          <div
            className="mb-4 flex-1 text-gray-700 [&_ul]:list-disc [&_ul]:space-y-1 [&_ul]:pl-5"
            dangerouslySetInnerHTML={{
              __html: sanitize(product.productDescription.value),
            }}
          />
        )}
        {product.ctaButtonLink?.value?.href && (
          <div className="mt-auto">
            <Button
              variant="primary"
              size="l"
              className="w-full xs:w-auto"
              onClick={handleProductClick}
              {...(product.ctaButtonAriaLabel?.value && {
                'aria-label': product.ctaButtonAriaLabel.value,
              })}
            >
              {product.ctaButtonText?.value || translations.learnmore}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
